export default "__VITE_ASSET__BOBn5TzI__"